import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StorageService } from '../../../services/storage.service';
import { ApiService } from '../../../services/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {

  constructor(private storageService: StorageService, private apiService: ApiService, private router: Router) { }

  formLogin!: FormGroup;
  formOtp!: FormGroup;
  step: 'credentials' | 'otp' = 'credentials';
  pendingToken = '';

  ngOnInit(): void {

    this.formLogin = new FormGroup({
      username: new FormControl(null, Validators.required),
      password: new FormControl(null, [Validators.required, Validators.minLength(5)])
    });
    this.formOtp = new FormGroup({
      code: new FormControl(null, [Validators.required, Validators.pattern(/^\d{6}$/)])
    });

    const user = this.storageService.getUser();
    const token = this.storageService.getToken();
    if (user?.id && token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (!payload?.id || payload?.otpPending) {
          this.storageService.clearStorage();
          return;
        }
      } catch {
        this.storageService.clearStorage();
        return;
      }
      this.apiService.isAuthorized().subscribe({
        next: (res) => {
          const ok = res === true || (res && typeof res === 'object' && res.result === true && !!(res as { data?: { id?: number } }).data?.id);
          if (ok) {
            this.router.navigate(['/backoffice']);
          } else {
            this.storageService.clearStorage();
          }
        },
        error: () => this.storageService.clearStorage(),
      });
    } else if (user || token) {
      this.storageService.clearStorage();
    }
  }

  private completeLogin(res: any) {
    this.storageService.setUser({
      user: res.user,
      email: res.email,
      tipo: res.tipo,
      id: res.id,
      mustChangePassword: !!res.mustChangePassword,
    });
    this.storageService.setToken(res.accessToken);
    this.router.navigate(['/backoffice']);
  }

  onLogin() {
    this.apiService.login(this.formLogin.get('username')?.value, this.formLogin.get('password')?.value).subscribe({
      next: (res) => {
        if (res?.requiresOtp && res?.pendingToken) {
          this.pendingToken = res.pendingToken;
          this.step = 'otp';
          this.formOtp.reset();
          return;
        }
        this.completeLogin(res);
      },
      error: () => this.apiService.message('error', 'Errore', 'Credenziali errate!'),
    });
  }

  onOtp() {
    this.apiService.loginOtp(this.pendingToken, String(this.formOtp.get('code')?.value || '')).subscribe({
      next: (res) => this.completeLogin(res),
      error: (err) => this.apiService.message('error', 'Errore', err.error?.message?.message || 'Codice OTP non valido'),
    });
  }

  backToCredentials() {
    this.step = 'credentials';
    this.pendingToken = '';
  }

}
